"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TagTypes = void 0;
var TagTypes;
exports.TagTypes = TagTypes;
(function (TagTypes) {
  TagTypes["Bonus"] = "bonus";
})(TagTypes || (exports.TagTypes = TagTypes = {}));